export default __webpack_public_path__ + "static/media/photo_placeholder.6a1e0267.svg";